<template>
  <div>
    <vxe-grid
      ref="skuTable"
      border
      auto-resize
      highlight-hover-row
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="tableData"
      :columns="tableColumns"
      cell-class-name="align-top"
      size="mini"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU:</span><span style="color: #409EFF">{{ row.evgSkuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:displayColor="{ row }">
        <span style="color: #303133">{{ row.goodsSize }}</span>
        <br />
        <span style="color: #303133"
          >{{ row.goodsColor }} &nbsp; {{ row.goodsColorEn }}</span
        >
        <br />
        <span style="color: #303133">{{ row.goodsPattern }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './sku-table-columns'
import { format } from '@/libs/util.number.js'
export default {
  props: { tableData: { type: Array, default: () => [] } },
  data() {
    return {
      format: (number) => format(number),
      tableColumns: tableColumns(this),
      editRules: {
        // whSkuNo: [
        //   {
        //     required: true,
        //     message: this.$l('rules_shelves_whSkuNo') || '请输入仓库SKU编号',
        //   },
        // ],
        // whSkuBarcode: [
        //   {
        //     required: true,
        //     message: this.$l('rules_shelves_whSkuBarcode') || '请输入仓库条码',
        //   },
        // ],
        // whReferenceNo: [
        //   {
        //     required: true,
        //     message:
        //       this.$l('rules_shelves_whReferenceNo') || '请输入自定义编码',
        //   },
        // ],
        // whProductTitle: [
        //   {
        //     required: true,
        //     message:
        //       this.$l('rules_shelves_whProductTitle') || '请输入仓库产品名称',
        //   },
        // ],
        declaredValue: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue && cellValue < 0) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
      },
    }
  },
  methods: {
    getTableData() {
      const { fullData } = this.$refs.skuTable.getTableData()
      return (fullData || []).map((item) => {
        const { brandCodeText: brandName } = item
        return { ...item, brandName }
      })
    },
    async validate() {
      const result = await this.$refs.skuTable.validate(true)
      return !result
    },
    del(row) {
      this.$emit('delRow', row)
      // this.$refs.skuTable.remove(row)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
